document.addEventListener('DOMContentLoaded', () => {
  // IR Image Card Animation System
  class IRImageCardAnimations {
    constructor() {
      this.animatedElements = [];
      this.init();
    }

    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupAnimations());
      } else {
        this.setupAnimations();
      }
    }

    setupAnimations() {
      // Find all elements with animation classes
      const animateElements = document.querySelectorAll('.ir-animate-fade-up, .ir-animate-slide-right, .ir-animate-scale');
      
      if (animateElements.length === 0) return;

      // Create intersection observer
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animateElement(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      // Observe all animation elements
      animateElements.forEach(element => {
        observer.observe(element);
      });
    }

    animateElement(element) {
      const delay = parseInt(element.getAttribute('data-delay')) || 0;
      
      setTimeout(() => {
        element.classList.add('ir-animated');
        
        // Add special effects for specific elements
        if (element.classList.contains('ir-image-card__image')) {
          this.animateImage(element);
        }
        
        if (element.classList.contains('ir-image-card__pill')) {
          this.animatePill(element);
        }
        
        if (element.classList.contains('ir-image-card__title')) {
          this.animateTitle(element);
        }
      }, delay);
    }

    animateImage(element) {
      const img = element.querySelector('.ir-image-card__img');
      
      if (img) {
        setTimeout(() => {
          img.style.transform = 'scale(1.1)';
          setTimeout(() => {
            img.style.transform = 'scale(1)';
          }, 400);
        }, 300);
      }
    }

    animatePill(element) {
      setTimeout(() => {
        element.style.transform = 'scale(1.1) translateY(-5px)';
        element.style.background = '#4B5646';
        element.style.color = '#F0E4D8';
        setTimeout(() => {
          element.style.transform = 'scale(1) translateY(0)';
          element.style.background = '#F0E4D8';
          element.style.color = '#4B5646';
        }, 300);
      }, 200);
    }

    animateTitle(element) {
      setTimeout(() => {
        element.style.transform = 'translateY(-10px)';
        element.style.color = '#CDAC83';
        setTimeout(() => {
          element.style.transform = 'translateY(0)';
          element.style.color = '#4B5646';
        }, 400);
      }, 200);
    }
  }

  // Enhanced hover effects for image cards
  const imageCards = document.querySelectorAll('[data-ir-image-card]');
  
  imageCards.forEach(card => {
    const container = card.querySelector('.ir-image-card__container');
    const image = card.querySelector('.ir-image-card__img');
    const pills = card.querySelectorAll('.ir-image-card__pill');
    
    if (container) {
      container.addEventListener('mouseenter', () => {
        // Add hover effects
        if (image) {
          image.style.transform = 'scale(1.05)';
          image.style.filter = 'brightness(1.1)';
        }
        
        pills.forEach((pill, index) => {
          setTimeout(() => {
            pill.style.transform = 'translateY(-2px) scale(1.05)';
          }, index * 50);
        });
      });
      
      container.addEventListener('mouseleave', () => {
        // Remove hover effects
        if (image) {
          image.style.transform = 'scale(1)';
          image.style.filter = 'brightness(1)';
        }
        
        pills.forEach(pill => {
          pill.style.transform = 'translateY(0) scale(1)';
        });
      });
    }
  });

  // Initialize animations
  const irImageCardAnimations = new IRImageCardAnimations();
});
